
import React from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

const BASE_URL = "https://www.nuvoco.com";

const STATIC_SITEMAP = [
  {
    name: "Corporate",
    links: [
      { title: "Home", url: "/" },
      { title: "About Us", url: "/about-us" },
      { title: "Our Journey", url: "/our-journey" },
      { title: "Quality & Innovation", url: "/quality-and-innovation" },
      { title: "Our Brands", url: "/our-brands" },
      { title: "Sustainability", url: "/sustainability" },
      { title: "Health & Safety", url: "/health-and-safety" },
      { title: "Life at Nuvoco", url: "/life-at-nuvoco" },
      { title: "Careers / EVP", url: "/our-employee-value-proposition" },
      { title: "Press Releases", url: "/media/Press-Releases" },
      { title: "Contact Us", url: "/contact-us" },
      { title: "Vadraj Cement", url: "/vadrajcement" },
    ],
  },
  {
    name: "Products",
    links: [
      { title: "Concreto Cement", url: "/products/concreto-cement" },
      { title: "Concreto Uno", url: "/products/concreto-uno" },
      { title: "Double Bull Master Cement", url: "/products/double-bull-master-cement" },
      { title: "Double Bull PPC", url: "/products/double-bull-ppc" },
      { title: "Double Bull PSC", url: "/products/double-bull-psc" },
      // { title: "Nirmax OPC", url: "/products/nirmax-opc" },
      { title: "P.S.C", url: "/products/p-s-c" },
      { title: "Duraguard Cement", url: "/products/duraguard-cement" },
      { title: "Duraguard Microfiber Cement", url: "/products/duraguard-microfiber-cement" },
      { title: "Duraguard OPC", url: "/products/duraguard-cement-opc" },
      { title: "Infracem Cement", url: "/products/infracem-cement" },
      { title: "Artiste Bare", url: "/products/artiste-bare" },
      { title: "Artiste Coarse", url: "/products/artiste-coarse" },
      { title: "Artiste Engrave", url: "/products/artiste-engrave" },
      { title: "Artiste Hue", url: "/products/artiste-hue" },
      { title: "Artiste Lumos", url: "/products/artiste-lumos" },
      { title: "Ecodure", url: "/products/ecodure" },
      { title: "Ecodure Plus", url: "/products/ecodure-plus" },
      { title: "Ecodure Prime", url: "/products/ecodure-prime" },
      { title: "X-Con", url: "/products/x-con" },
      { title: "Instamix", url: "/products/instamix" },
      { title: "Instamix Microne", url: "/products/instamix-microne" },
      { title: "Instamix Mortare", url: "/products/instamix-mortare" },
      { title: "Artiste Signature", url: "/products/artiste-signature" },
      { title: "Zero-M IWC", url: "/products/nuvoco-zero-m-iwc" },
      { title: "Zero-M 2K", url: "/products/nuvoco-zero-m-2k" },
      { title: "Zero-M Wall Putty", url: "/products/nuvoco-zero-m-wall-putty" },
      { title: "Zero-M Dry Plaster", url: "/products/nuvoco-zero-m-dry-plaster" },
      { title: "Zero-M Tile Adhesive T1", url: "/products/nuvoco-zero-m-tile-adhesive-t1" },
      { title: "Zero-M Tile Adhesive T2", url: "/products/nuvoco-zero-m-tile-adhesive-t2" },
      { title: "Zero-M Tile Adhesive T3", url: "/products/nuvoco-zero-m-tile-adhesive-t3" },
      { title: "Zero-M Tile Adhesive T4", url: "/products/nuvoco-zero-m-tile-adhesive-t4" },
      { title: "Zero-M Tile Adhesive T5", url: "/products/nuvoco-zero-m-tile-adhesive-t5" },
      { title: "Zero-M Roof Shield", url: "/products/nuvoco-zero-m-roof-shield" },
      { title: "Zero-M Cover Block", url: "/products/nuvoco-zero-m-cover-block" },
      { title: "Zero-M Epoxy Tile Grout", url: "/products/nuvoco-zero-m-epoxy-tile-grout" },
      { title: "Zero-M Tile Grout", url: "/products/nuvoco-zero-m-tile-grout" },
      { title: "Triple Shield Putty", url: "/products/nuvoco-zero-m-triple-shield-putty" },
    ],
  },
  {
    name: "Our Businesses",
    links: [
      { title: "Top Cement Company", url: "/top-cement-company" },
      { title: "Ready-Mix Concrete", url: "/ready-mix-concrete" },
      { title: "Modern Building Materials", url: "/modern-building-materials" },
    ],
  },
  {
    name: "Media & Investor Relations",
    links: [
      { title: "Press Releases", url: "/media/Press-Releases" },
      { title: "Investors Corner", url: "/investors-corner" },
    ],
  },
];

const Sitemap = () => {
  const { lng } = useParams();
  const langPrefix = lng ? `/${lng}` : "";

  return (
    <div style={{ background: "#f9fafb", padding: "120px 0 60px 0" }}>
      <Helmet>
        <title>Sitemap | Nuvoco Vistas</title>
        <meta name="description" content="Nuvoco Vistas website HTML sitemap. Find all pages and products." />
      </Helmet>

      <Container>
        {/* Page Heading */}
        <div className="text-center mb-5">
          <span style={{
            display: "inline-block",
            letterSpacing: "2px",
            color: "#e31e24",
            fontWeight: "600",
            fontSize: "13px",
            textTransform: "uppercase",
            marginBottom: "10px"
          }}>
            Easy Navigation
          </span>
          <h1 style={{ fontSize: "40px", fontWeight: "700", color: "#1f2937", margin: 0 }}>
            HTML Sitemap
          </h1>
          <div style={{ marginTop: "20px" }}>
            <a
              href={langPrefix ? `${langPrefix}/sitemap.xml` : "/sitemap.xml"}
              download={lng ? `${lng}-sitemap.xml` : "sitemap.xml"}
              style={{
                display: "inline-block",
                backgroundColor: "#e31e24",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "5px",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "14px",
                transition: "background-color 0.2s"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c81a20")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#e31e24")}
            >
              Download XML Sitemap
            </a>
          </div>
        </div>

        {/* Single-column sitemap list */}
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          {STATIC_SITEMAP.map((category, catIdx) => (
            <div key={catIdx} style={{ marginBottom: "48px" }}>
              {/* Category Heading */}
              <h2 style={{
                fontSize: "18px",
                fontWeight: "700",
                color: "#1f2937",
                borderLeft: "4px solid #e31e24",
                paddingLeft: "12px",
                marginBottom: "8px"
              }}>
                {category.name}
              </h2>

              {/* One full URL per row */}
              {category.links.map((link, linkIdx) => (
                <div
                  key={linkIdx}
                  style={{
                    borderBottom: "1px solid #e5e7eb",
                    padding: "10px 0 10px 16px",
                  }}
                >
                  <a
                    href={BASE_URL + langPrefix + link.url}
                    style={{
                      color: "#374151",
                      textDecoration: "none",
                      fontSize: "15px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "color 0.15s ease",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#e31e24")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#374151")}
                  >
                    <span style={{ color: "#e31e24", fontSize: "18px", lineHeight: 1, flexShrink: 0 }}>›</span>
                    {BASE_URL + langPrefix + link.url}
                  </a>
                </div>
              ))}
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Sitemap;
